import loadable from '@loadable/component';

export const AsyncToaster = loadable(
    () =>
        import(
            /* webpackChunkName: "toaster" */
            /* webpackPrefetch: true */
            './ToasterAsDefault'
        ),
    {ssr: false}
);
